import * as React from 'react';
import ADSRDisplay from './ADSRDisplayGL';
import TouchSlider from './TouchSlider';
import Test from './TestReactGL';

const EnvelopeView = ({ envParams, setEnv, width }) => {
	const sliderGen = (k, min, max) => <div />;

	return (
		<div
			style={{
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				// border:"black",borderStyle:"solid", borderWidth:"1px",
			}}
		>
			<div style={{ width: '100%', height: '55%', margin: 'auto' }}>
				<ADSRDisplay a={envParams.attack} d={envParams.decay} s={envParams.sustain} r={envParams.release} />
				{/* <Test a={envParams.attack} d={envParams.decay} s={envParams.sustain} r={envParams.release}></Test> */}
			</div>
			{[
				{ key: 'attack', label: 'A', max: 1 },
				{ key: 'decay', label: 'D', max: 1 },
				{ key: 'sustain', label: 'S', max: 1 },
				{ key: 'release', label: 'R', max: 5 },
			].map(obj => (
				<div key={obj.label} style={{ width: '100%', height: '11%', margin: 'auto', marginTop: 0 }}>
					<TouchSlider
						defaultValue={envParams[obj.key]}
						setValue={v => {
							setEnv(obj.key, v);
						}}
						min={0.01}
						max={obj.max}
						label={obj.label}
					/>
				</div>
			))}
		</div>
	);
};

export default EnvelopeView;
